export default __webpack_public_path__ + "static/media/empty-direction.f6baa784.svg";